import { render, staticRenderFns } from "./SidebarListFaces.vue?vue&type=template&id=698b9e58"
import script from "./SidebarListFaces.vue?vue&type=script&lang=js"
export * from "./SidebarListFaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports